// extracted by mini-css-extract-plugin
export default {"doctors-list":"AdminDoctorList_doctors-list__tEKh4","DoctorslistContainer":"AdminDoctorList_DoctorslistContainer__bMvo5","loader":"AdminDoctorList_loader__hWqGM"};